<template>
  <div class="pa-5">
    <v-container fluid>
      <v-row align-content="center">
        <!--right com-->
        <v-col md="3" cols="12">
          <marketsList />
        </v-col>
        <!--center com-->
        <v-col md="7" cols="12">
          <currentCard />
          <tradeCharts :current-coin="currentCoin" />
          <tradeForms @refresh="refresh" ref="tradeForms" />
        </v-col>
        <v-col md="2" cols="12">
          <template v-if="currentCoin">
            <preMarket
              v-if="showPremarket"
              :countDownBgColor.sync="countDownBgColor"
              :publishState.sync="publishState"
              :clearTime="currentCoin.clearTime"
              :currentTime="parseInt(currentCoin.currentTime / 1000)"
              :endTime="currentCoin.endTime"
              :publishType="currentCoin.publishType"
              :startTime="currentCoin.startTime"
              @hidePremarket="hidePremarket"
              @hidePublishMask="hidePublishMask"
              @showPublishMask="showPublishMask"
            />
          </template>
          <plateTables @updateTradeForms="updateTradeForms" />
        </v-col>
        <v-col cols="12">
          <orderTables
            v-if="currentCoin && isAuth"
            :key="reloadData || $route.params.pair"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import preMarket from "@/components/Market/exchange/preMarket.vue";
import marketsList from "@/components/Market/exchange/MarketList.vue";
import currentCard from "@/components/Market/exchange/currentCard.vue";
import plateTables from "@/components/Market/exchange/plateTables.vue";
import orderTables from "@/components/Market/exchange/orderTables.vue";
import tradeForms from "@/components/Market/exchange/tradeForms/index.vue";
import tradeCharts from "@/components/Market/exchange/tradeCharts/index.vue";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import { authMixin } from "@/mixins/authMixin";
import dayjs from "@/utiles/dayjs";

export default {
  name: "exchange",
  mixins: [authMixin],
  components: {
    orderTables,
    plateTables,
    currentCard,
    marketsList,
    tradeForms,
    tradeCharts,
    preMarket
  },
  data() {
    return {
      countDownBgColor: "#003478",
      publishState: 0,
      reloadData: false
    };
  },
  mounted() {
    if (!this.$route.params.pair) {
      this.$router.push({
        path: `/exchange/USDT_IRR`
      });
    }
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN
    }),
    showPremarket: {
      get() {
        if (
          dayjs(this.currentCoin.currentTime).format("YYYY-MM-DD HH:mm:ss") <
          this.currentCoin.clearTime
        ) {
          return (
            this.currentCoin.publishType === "QIANGGOU" ||
            this.currentCoin.publishType === "FENTAN"
          );
        } else {
          return false;
        }
      },
      set(newValue) {
        return newValue;
      }
    },
    showPublishMarket: {
      get() {
        if (
          dayjs(this.currentCoin.currentTime).format("YYYY-MM-DD HH:mm:ss") <
          this.currentCoin.clearTime
        ) {
          return (
            this.currentCoin.publishType === "QIANGGOU" ||
            this.currentCoin.publishType === "FENTAN"
          );
        } else {
          return false;
        }
      },
      set(newValue) {
        return newValue;
      }
    }
  },
  methods: {
    showPublishMask() {
      if (!this.showPublishMarket) {
        this.showPublishMarket = true;
      }
    },
    hidePublishMask() {
      if (this.showPublishMarket) {
        this.showPublishMarket = false;
      }
    },
    hidePremarket() {
      if (this.showPremarket) {
        this.showPremarket = false;
      }
    },
    updateTradeForms(itemValue) {
      this.$refs.tradeForms.$refs.form.setPLateData(itemValue.price);
    },
    refresh() {
      this.reloadData = !this.reloadData;
    }
  }
};
</script>

<style lang="scss">
.current-market-card {
  .v-btn__content {
    .svg-color-secondary {
      path:last-child {
        fill: var(--v-secondary-base);
        stroke: var(--v-secondary-base);
      }
    }
  }
}
</style>
